module.exports = __webpack_public_path__ + "img/35_39.57dddda4.png";